import { styled, css } from "styled-components";
import media from "../../../../../styles/mediaQueries";
import Colors from "../../../../../styles/Colors";
export const SearchBar = styled.div `
  position: relative;
  margin-bottom: 15px;
`;
export const Form = styled.form `
  position: relative;
  margin-bottom: 0;
`;
export const SearchIconWrapper = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 10px;
  width: 26px;
  height: 26px;
  cursor: pointer;
  pointer-events: none;

  svg {
    display: inline-block;
    background-size: 100% !important;
    color: ${Colors.PROFILE_RED_2024};
    fill: ${Colors.PROFILE_RED_2024};
  }
`;
export const SearchLabel = styled.label `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
export const SearchInput = styled.input `
  display: block;
  height: 50px;
  width: 100%;
  line-height: 51px;
  padding-left: 50px;
  border-style: solid;
  transition: all 0.15s ease-out;
  color: #333;
  font-size: 15px;
  border-width: 1px;
  border-color: #dfdfdf;
  background: rgba(255, 255, 255, 0.5);
  margin-bottom: 0;

  &:focus {
    background: #fff;
    width: 100%;
    outline: 0 !important;
    box-shadow: inset 0 1px 1px rgba(51, 51, 51, 0.075),
      0 0 8px rgba(51, 51, 51, 0.6) !important;
    border: 1px solid #999 !important;
  }
`;
export const MenuSearch = styled.div `
  margin-bottom: 15px;
`;
export const MenuSection = styled.div `
  clear: both;
  float: left;
  width: 100%;
  margin-top: 0;
  margin-bottom: -20px;

  &:before {
    display: table;
    content: " ";
  }

  ${media.up("small") `
    margin-top: 1em;
    column-count: 2;
    column-gap: 20px;
    overflow: hidden;
  `}

  ${media.up("large") `
    margin-bottom: -50px;
    margin-top: 1.2em;
  `}


  ${(props) => props.isSearchActive &&
    css `
      opacity: 0;
      z-index: -1;
      display: none;
    `}
`;
export const MenuLinks = styled.div `
  transition: all 0.6s cubic-bezier(0.27, 0.74, 0.32, 1.01);
  opacity: 1;
  margin: 22px 0;

  ${media.up("small") `
    display: inline-block;
    margin: 0 0 25px;
    border-left: 2px dotted rgba(0,0,0,.25);
    min-width: 180px;
  `}
  ${media.up("medium") `
    min-width: 220px;
  `}
  ${media.only("medium", "belowLarge") `
    margin: 12px 0;
  `}

  h5 {
    color: ${Colors.PROFILE_RED_2024};
    font-weight: 600;
    padding-left: 0;
    font-size: 16px;
    margin: 0;

    ${media.up("small") `
      padding-left: 17px;
      font-size: 18px;
      margin-bottom: 3px;
    `}
    ${media.down("belowLarge") `
      font-size: 14px;
    `}
    ${media.only("large", "xlarge") `
      font-size: 14px;
    `}
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    li {
      line-height: 24px;
      margin-left: -2px;
      margin-bottom: 0;
      margin-top: 0;
      border-left: 2px solid transparent;
      ${media.up("small") `
        padding-left: 17px;
      `}

      a {
        padding-top: 2px;
        padding-bottom: 2px;
        display: block;
        color: #333;
        text-decoration: none !important;
        font-size: 16px;

        ${media.only("medium", "belowLarge") `
          font-size: 15px;
        `}
        ${media.only("large", "xlarge") `
          font-size: 15px;
        `}
      }
    }
  }
`;
export const MenuLinkAnchor = styled.a ``;
export const SearchSuggestions = styled.div `
  background: #fff;
  width: 100%;
  transition: all 0.5s ease-in-out;
  opacity: 0;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  ${(props) => props.isActive &&
    css `
      visibility: visible;
      height: auto;
      opacity: 1;
      transition: all 0.2s ease-in-out;
    `}
`;
export const SearchSuggestionActions = styled.div `
  text-align: center;
  display: flex;
  justify-content: center;
`;
export const SearchSuggestionsHeader = styled.h2 `
  text-align: center;
  color: #333;
  margin: 0;
  width: 100%;
  position: relative;
  font-size: 18px;
  padding: 1em 0;
`;
export const AbortSearchButton = styled.div `
  display: inline-block;
  margin: 0.5em;
`;
export const ShowMoreButton = styled.div `
  display: inline-block;
  color: #000;
  margin: 0.5em 0.5em 0.5em 3px;
`;
//# sourceMappingURL=style.js.map